__turbopack_context__.v({
  "breakWordText": "ReviewCard-module__NMTfeG__breakWordText",
});
